import { IPromise, IQService } from "angular";

import { IAccess } from "../sessions/models/models";
import { PermissionsService } from "../users/permissions-service";
import { UserService } from "../users/userService";
import { IGtmhubRootScopeService } from "../models";

// service that initializes effective permissions in the root scope
export class EffectivePermissionsService {
  public static $inject = ["$rootScope", "PermissionsService", "$q", "UserService"];

  constructor(private $rootScope: IGtmhubRootScopeService, private permissionsService: PermissionsService, private $q: IQService, private userService: UserService) {}

  public initEffectivePermissions(): IPromise<string[]> {
    let effectivePermissionsPromise: IPromise<string[]>;
    if (typeof this.$rootScope.effectivePermissions !== "undefined" && this.$rootScope.effectivePermissions) {
      effectivePermissionsPromise = this.$q.resolve(this.$rootScope.effectivePermissions);
    } else {
      effectivePermissionsPromise = this.permissionsService.getEffectivePermissions();
      effectivePermissionsPromise.then((effectivePermissions) => {
        this.$rootScope.effectivePermissions = effectivePermissions;
      });
    }
    return effectivePermissionsPromise;
  }

  public allowedActions(userId: string, accessObject: IAccess): IPromise<string[]> {
    const allowedActions = [];
    const deferred = this.$q.defer<string[]>();
    const accessIds = [];
    // build access principals
    for (let i = 0; i < accessObject.permissions.length; i++) {
      accessIds[accessObject.permissions[i].principalId] = accessObject.permissions[i].grant.general;
    }

    const userPrincipalIds = [];
    // first putting the user himself
    userPrincipalIds.push(userId);

    // then the roles
    this.userService.getUser(userId).then(
      (user) => {
        // then the account
        userPrincipalIds.push(user.accountId);

        for (let i = 0; i < user.roles.length; i++) {
          userPrincipalIds.push(user.roles[i].id);
        }

        for (let i = 0; i < userPrincipalIds.length; i++) {
          if (accessIds[userPrincipalIds[i]]) {
            for (let s = 0; s < accessIds[userPrincipalIds[i]].length; s++) {
              if (allowedActions.indexOf(accessIds[userPrincipalIds[i]][s]) === -1) {
                allowedActions.push(accessIds[userPrincipalIds[i]][s]);
              }
            }
          }
          deferred.resolve(allowedActions);
        }
      },
      (error) => {
        // if error when getting user pass the error object received to controller
        deferred.reject(error);
      }
    );

    return deferred.promise;
  }
}
